import React from 'react';
import {
  makeStyles,
  Container,
  Box,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Card,
  CardHeader
} from '@material-ui/core';
import { useQuery } from 'react-query';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Page from 'src/components/Page';
import TablePagination from 'src/components/TablePagination';
import useQueryString from 'src/hooks/useQueryString';
import wallet from 'src/api/wallet';
import TransactionRow from 'src/components/TransactionRow';
// import Filter from './Filter';

const useStyles = makeStyles(() => ({
  root: {},
  nowrap: {
    whiteSpace: 'nowrap'
  }
}));

export default function WalletTransactions() {
  const classes = useStyles();

  const [query, setQueryString] = useQueryString();

  const { data = {} } = useQuery(
    ['allTransactions', query],
    () => wallet.getAllWalletTransactions(query),
    {
      keepPreviousData: true
    }
  );

  const { data: withdrawals = [] } = data;
  return (
    <Page className={classes.root} title="Wallet Transactions">
      <Container maxWidth={false}>
        <Box mb={4}>
          <Card>
            <CardHeader title="Wallet Transactions" />
          </Card>
          {/* <Filter defaultValues={query} /> */}
        </Box>
        <Card>
          <PerfectScrollbar>
            <Box minWidth={1050}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Type</TableCell>
                    <TableCell>Previous Balance</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Balance</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Summary</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {withdrawals.map(withdraw => (
                    <TransactionRow
                      key={withdraw.id}
                      transaction={withdraw}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          {data.pagination && (
            <TablePagination
              count={data.pagination.totalCount}
              page={data.pagination.currentPage}
              rowsPerPage={data.pagination.rows}
              onChangeRowsPerPage={rows => setQueryString({ rows })}
              onChangePage={pageNo => setQueryString({ pageNo })}
            />
          )}
        </Card>
      </Container>
    </Page>
  );
}
